import { render, staticRenderFns } from "./pl5.vue?vue&type=template&id=7928c25f&scoped=true"
var script = {}
import style0 from "./pl5.vue?vue&type=style&index=0&id=7928c25f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7928c25f",
  null
  
)

export default component.exports